<template>
  <div class="ui basic segment">
    <div class="ui header">Google Drive Backups</div>
    <div class="ui form" style="margin-bottom: 30px;">
      <div class="field">
        <label>Google Project Client ID</label>
        <input type="text" :value="googleClientId" @input="setGoogleClientId($event.target.value)" placeholder="xxxxxxx">
      </div>
      <div class="field">
        <label>Google Drive API Key</label>
        <input type="text" :value="googleDriveApiKey" @input="setGoogleDriveApiKey($event.target.value)" placeholder="xxxxxx">
      </div>
      <div class="field">
        <div class="ui checkbox">
          <input id="enableAutoBackup" type="checkbox" :checked="enableAutoBackup" @input="setEnableAutoBackup($event.target.checked)">
          <label for="enableAutoBackup">Aktiviere Auto Backup (alle 4 Stunden)</label>
        </div>
      </div>
    </div>
    <button class="ui tiny inverted orange labeled icon button" @click="setupGoogleAuthentication" :disabled="!googleCredentialsGiven">
      Mit Google authentifizieren
      <i class="ui step key icon"></i>
    </button>
    <template v-if="accessToken">
      <button :disabled="requestsOngoing > 0 || !googleCredentialsGiven" class="ui tiny inverted labeled icon blue button" @click="listGoogleDriveFiles(20)">
        <i class="ui step file icon"></i>
        Backups laden
      </button>
      <button :disabled="requestsOngoing > 0 || !googleCredentialsGiven" class="ui tiny inverted green labeled icon button" @click="createBackupFile">
        Backup anlegen
        <i class="ui step cloud icon"></i>
      </button>
      <div class="ui small header">Aktuelle Timelog-Daten</div>
      <ul>
        <li>Anzahl geloggter Tage: {{ currentMetadata.totalLoggedDays }}</li>
        <li>Anzahl Logs gesamt: {{ currentMetadata.totalLogs }}</li>
      </ul>
      <div class="ui small header">Verfügbare Backups</div>
      <table class="ui compact table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Erstellt</th>
            <th>Größe</th>
            <th>Anzahl geloggter Tage</th>
            <th>Anzahl Logs gesamt</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(file, f) in files" :key="'file-' + f">
            <td>{{ file.name }}</td>
            <td>{{ getRelative(file.createdTime) }}</td>
            <td>{{ getFileSizeReadable(file.size) }}</td>
            <td>{{ file.appProperties ? file.appProperties.totalLoggedDays : '' }}</td>
            <td>{{ file.appProperties ? file.appProperties.totalLogs : '' }}</td>
            <td>
              <button class="ui tiny inverted primary labeled icon button" :disabled="requestsOngoing > 0" title="Dieses Backup laden" @click="loadBackupByFile(file)">
                Laden
                <i class="ui step download icon"></i>
              </button>
              <button class="ui tiny inverted red icon button" :disabled="requestsOngoing > 0" title="Dieses Backup löschen" @click="deleteDriveFile(file)">
                <i class="ui step delete icon"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </template>
  </div>
</template>

<script>
import moment from 'moment'
import {EventBus} from '@/eventBus';
import {mapGetters, mapMutations} from 'vuex';

const GOOGLE_DRIVE_DISCOVERY_DOC = 'https://www.googleapis.com/discovery/v1/apis/drive/v3/rest';

export default {
  name: 'GoogleDriveBackup',
   data() {
     return {
        oauthTokenClient: null,
        accessToken: null,
        files: null,
        requestsOngoing: 0,
        autoBackup: {
           lastCreated: null,
           interval: null
        }
     }
   },
   mounted() {
     //TODO: wait until google libs are loaded
     setTimeout(() => {
        this.initClient()
     },1000)

     this.autoBackup.interval = setInterval(this.checkAutoBackup, 1000 * 60 * 5); // every five minutes
   },
   beforeDestroy () {
     if (this.autoBackup.interval) {
        clearInterval(this.autoBackup.interval)
     }
   },
   computed: {
      ...mapGetters({
        googleClientId: 'googleClientId',
        googleDriveApiKey: 'googleDriveApiKey',
        enableAutoBackup: 'enableAutoBackup'
      }),
      currentMetadata () {
        let logDataJson = localStorage.getItem('data');
        try {
          return this.getMetadataByLogData(JSON.parse(logDataJson))
        } catch (e) {
          console.warn(e)
          return {}
        }
      },
      googleCredentialsGiven () {
         return this.googleClientId && this.googleDriveApiKey;
      }
   },
   methods: {
      ...mapMutations([
        'setGoogleClientId',
        'setGoogleDriveApiKey',
        'setEnableAutoBackup'
      ]),
      initClient () {
        // TODO use vuex store
         this.accessToken = JSON.parse(window.localStorage.getItem('google_authentication'))

         if (!this.googleCredentialsGiven) {
             return;
         }

         this.oauthTokenClient = window.google.accounts.oauth2.initTokenClient({
            client_id: this.googleClientId,
            scope: 'https://www.googleapis.com/auth/drive.appfolder',
            callback: (tokenResponse) => {
               this.accessToken = tokenResponse;
               // TODO use vuex store
               window.localStorage.setItem('google_authentication', JSON.stringify(this.accessToken))
               console.log('google_authentication', this.accessToken)
               setTimeout(this.listGoogleDriveFiles, 700)
            },
            error_callback: (tokenResponse) => {
               console.error('error callback', tokenResponse)
            },
         });

         window.gapi.load('client', () => {
            window.gapi.client.init({
               apiKey: this.googleDriveApiKey,
               discoveryDocs: [GOOGLE_DRIVE_DISCOVERY_DOC],
            });
            if(this.accessToken) {
               console.log('loaded access token')
               window.gapi.client.setToken(this.accessToken)
               setTimeout(this.listGoogleDriveFiles, 700)
            }
         });
      },
      setupGoogleAuthentication () {
         const token = window.gapi.client.getToken()
         console.log(token)
         if (token === null || token.access_token == null) {
            console.log('asking for consent')
            // Prompt the user to select a Google Account and ask for consent to share their data
            // when establishing a new session.
            this.oauthTokenClient.requestAccessToken({prompt: 'consent'});
         } else {
            console.log('asking without prompt')
            // Skip display of account chooser and consent dialog for an existing session.
            this.oauthTokenClient.requestAccessToken({prompt: ''});
            // this.oauthTokenClient.requestAccessToken({prompt: 'none'});
         }
      },
      resetAccessToken () {
         this.accessToken = null;
         // TODO use vuex store
         window.localStorage.setItem('google_authentication', JSON.stringify(this.accessToken))
      },
      createBackupFile() {
         const currentDateTime = moment().format('YYYY-MM-DD_HH-mm-ss')
         let logDataJson = localStorage.getItem('data');
         let customMetadata = null;
         let logData
         try {
            logData = JSON.parse(logDataJson)
            customMetadata = this.getMetadataByLogData(logData)
         } catch (e) {
           console.warn(e)
         }
         if (customMetadata) {
           const filesWithMetaData = this.files == null ? [] : this.files
               .filter(file => file.appProperties && file.appProperties.totalLoggedDays);

           const loggedDaysInBackupsMinimum = filesWithMetaData.length === 0 ? 0 :
               Math.min(filesWithMetaData.map(file => file.appProperties.totalLoggedDays))

           if ((this.files == null || loggedDaysInBackupsMinimum > customMetadata.totalLoggedDays) && !confirm('Die Backups enthalten mehr Daten als der aktuelle Stand. Sollen die Backups überschrieben werden?')) {
             return;
           }
           customMetadata.userAgent = navigator.userAgent
         }
        const form = new FormData();
        const metadataJson = JSON.stringify({
          name: 'clockwork.backup.' + currentDateTime + '.json',
          mimeType: 'application/json',
          parents: ['appDataFolder'],
          appProperties: customMetadata
        });
        form.append('metadata', new Blob([metadataJson], { type: 'application/json' }));
        form.append('file', new Blob([logDataJson], {type: 'application/json'}));
        this.requestsOngoing++
        // Apparently gapi.client.drive.files.create cannot be used to simultaneously create file and upload file content
        fetch('https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart&fields=id', {
          method: 'POST',
          headers: {Authorization: 'Bearer ' + this.accessToken.access_token},
          body: form
        })
        .then(res => {
          this.requestsOngoing--
          return res.json()
        })
        .then((response) => {
            console.log('Datei erstellt. ID: ' + response.id);
            this.deleteOldBackupFiles()
            this.listGoogleDriveFiles()
         })
        .catch((err) => {
            console.error('Fehler beim Erstellen der Datei.', err);
          this.requestsOngoing--
         });
      },
      checkAutoBackup () {
         const logPrefix = '[AutoBackup]';
         if (!this.accessToken) {
            return;
         }
         if (!this.enableAutoBackup) {
            console.log(logPrefix, 'Auto backup disabled. Do nothing.')
            return;
         }
         console.log(logPrefix, 'Last auto backup created at:', this.autoBackup.lastCreated
           ? moment(this.autoBackup.lastCreated).fromNow()
           : 'Never'
         )
         // TODO defaults to every 4h, make autobackup interval configurable by user
         const autoBackupIntervalMs = 1000 * 60 * 60 * 4;

         if (!this.autoBackup.lastCreated || Date.now() - this.autoBackup.lastCreated > autoBackupIntervalMs) {
            // TODO check contents and only backup if changes detected
            this.createBackupFile();
            this.autoBackup.lastCreated = Date.now();
            console.log(logPrefix, 'Auto backup created');
         }
         const dateNextBackup = this.autoBackup.lastCreated + autoBackupIntervalMs;
         if (dateNextBackup > 0) {
            console.log(logPrefix, 'Next auto backup:', moment(dateNextBackup).fromNow())
         }
      },
      async deleteOldBackupFiles(keepFilesCount = 10) {
         if (this.files != null && this.files.length > keepFilesCount) {
            const filesCopy = JSON.parse(JSON.stringify(this.files))
            filesCopy.sort((a,b) => a.createdTime < b.createdTime)
            const filesToDelete = filesCopy.slice(keepFilesCount)
            for (const fileToDelete of filesToDelete) {
               await this.deleteDriveFileById(fileToDelete.id)
            }
         }
      },
      deleteDriveFileById(fileId) {
         console.log('deleting file with id', fileId)
         return window.gapi.client.drive.files.delete({
            fileId: fileId
         });
      },
      deleteDriveFile (file) {
        if (confirm('Dieses Backup wirklich löschen?')) {
          this.deleteDriveFileById(file.id)
          .then(() => {
            const index = this.files.indexOf(file)
            if (index >= 0) {
              this.files.splice(index, 1)
            }
          })
        }
      },
      listGoogleDriveFiles(fetchCount = 10) {
        this.requestsOngoing++
         window.gapi.client.drive.files.list({
            spaces: 'appDataFolder',
            pageSize: fetchCount,
            orderBy: 'createdTime desc',
            fields: 'files(id, name, createdTime, appProperties, size)',
         }).then((response) => {
            this.requestsOngoing--;
            this.files = response.result.files;
            console.table(JSON.parse(JSON.stringify(this.files)))
         }).catch((err) => {
            this.requestsOngoing--;
            console.error('Fehler beim Laden der Google Drive Dateien', err)
            if (err.status === 401) {
               this.resetAccessToken();
            }
         })
      },
      getMetadataByLogData (logData) {
        const metadata = {}
        try {
          console.log(logData)
          let totalLogs = 0;
          let dayList = Object.keys(logData).filter(key => (key + '').match(/\d{4}-\d{2}-\d{2}/));
          dayList.sort()
          dayList.forEach(day => totalLogs += (logData[day] ? logData[day].workLogs.length : 0))
          metadata.totalLoggedDays = dayList.length
          metadata.lastLoggedDay = dayList.length > 0 ? dayList[dayList.length - 1] : null
          metadata.totalLogs = totalLogs
        } catch (e) {
          console.warn(e)
        }
        return metadata
      },
      loadBackupByFile (file) {
        if (confirm('Dieses Backup wirklich laden?')) {
          this.requestsOngoing++;
          window.gapi.client.drive.files.get({
            fileId: file.id,
            alt: 'media'
          })
          .then((response) => {
            this.requestsOngoing--;
            console.debug('Loaded logs:', response.result)
            localStorage.setItem('data', JSON.stringify(response.result))
            EventBus.$emit('backupLoaded')
          })
          .catch((err) => {
            this.requestsOngoing--;
            console.error('Fehler beim Laden des Backups aus File', file, err)
          });
        }
      },
      testMetadata () {
        console.debug(this.getMetadataByLogData(JSON.parse(localStorage.getItem('data'))))
      },
      getRelative (dateString) {
        return moment(dateString).fromNow()
      },
      getFileSizeReadable (size) {
        size = parseInt(size);
        let unit = 'B'
        if (size > 1024) {
          size = Math.floor(size / 1024)
          unit = 'kB'
        }
        return `${size} ${unit}`
      }
   },
   watch: {
      googleClientId () {
         this.initClient();
      },
      googleDriveApiKey () {
         this.initClient();
      }
   }
}
</script>

<style scoped>

</style>
